import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { fa, db } from './db'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

let app

fa.onAuthStateChanged(user => {
  if (user) {
    db.collection('users').doc(user.uid).get().then(doc => {
      if (doc) store.dispatch('setUser', doc.data())
    })
  } else {
    store.dispatch('setUser', null)
  }

  if (!app) {
    db.collection('data').doc('2021').onSnapshot((doc) => { 
      store.dispatch('setPicks', (doc.data().picks) ? doc.data().picks : [])
      store.dispatch('setTeams', (doc.data().teams) ? doc.data().teams : [])
      store.dispatch('setStatus', doc.data().status)
    })
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app') 
  } 
})
